// // import React, { useState, useEffect, useRef } from "react";
// // import { getFreshAccessToken } from "../../chat/api";
// // import api from "../../chat/api";
// // import { toast } from "react-toastify";
// // import pdfImg from "./pdf.png";
// // import xlsImg from "./xls.png";
// // import docImg from "./doc.png";

// // const CreateProjectModal = ({ isOpen, onClose, onCreateProject }) => {
// //   const [projectName, setProjectName] = useState("");
// //   const [description, setDescription] = useState("");
// //   const [files, setFiles] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [buttonText, setButtonText] = useState("Create Project");
// //   const [isSuccess, setIsSuccess] = useState(false);
// //   const [isUploadingFiles, setIsUploadingFiles] = useState(false);
// //   const maxFileSizeMB = 25;

// //   const STATUS = {
// //     PENDING: "pending",
// //     UPLOADING: "uploading",
// //     SUCCESS: "success",
// //     ERROR: "error",
// //   };

// //   const wsRef = useRef(null);
// //   const fileInputRef = useRef(null);
// //   const successTimeoutRef = useRef(null);

// //   useEffect(() => {
// //     if (!isOpen) {
// //       if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
// //         wsRef.current.close();
// //       }
// //       if (successTimeoutRef.current) {
// //         clearTimeout(successTimeoutRef.current);
// //         successTimeoutRef.current = null;
// //       }

// //       setProjectName("");
// //       setDescription("");
// //       setFiles([]);
// //       setLoading(false);
// //       setButtonText("Create Project");
// //       setIsSuccess(false);
// //       setIsUploadingFiles(false);
// //     }
// //   }, [isOpen]);

// //   useEffect(() => {
// //     return () => {
// //       if (successTimeoutRef.current) {
// //         clearTimeout(successTimeoutRef.current);
// //       }
// //     };
// //   }, []);

// //   const handleFileChange = (e) => {
// //     const selectedFiles = e.target.files
// //       ? Array.from(e.target.files)
// //       : Array.from(e.dataTransfer.files);

// //     const validFiles = [];

// //     selectedFiles.forEach((file) => {
// //       if (file.size > maxFileSizeMB * 1024 * 1024) {
// //         toast.error(
// //           `File ${file.name} exceeds the maximum limit of ${maxFileSizeMB} MB.`
// //         );
// //         return;
// //       }

// //       if (!files.some((f) => f.file && f.file.name === file.name)) {
// //         validFiles.push({
// //           file,
// //           progress: 0,
// //           status: STATUS.PENDING,
// //           errorReason: null,
// //           key: null,
// //           file_id: null,
// //         });
// //       } else {
// //         toast.error(`File ${file.name} is already added.`);
// //       }
// //     });

// //     if (validFiles.length > 0) {
// //       setFiles((prev) => [...prev, ...validFiles]);
// //     }

// //     // Reset file input to allow re-selecting same file
// //     if (fileInputRef.current) {
// //       fileInputRef.current.value = null;
// //     }
// //   };

// //   // Create folder with files - triggered on button click
// //   const createFolderWithFiles = async () => {
// //     setIsUploadingFiles(true);
// //     setLoading(true);
// //     setButtonText("Creating Project...");

// //     // Update all pending files to uploading status
// //     setFiles((prev) =>
// //       prev.map((f) =>
// //         f.status === STATUS.PENDING ? { ...f, status: STATUS.UPLOADING } : f
// //       )
// //     );
    
// //     const filesToUpload = files.filter(f => f.status !== STATUS.ERROR);
// //     try {
// //       const token = await getFreshAccessToken();

// //       // Step 1: Open WebSocket connection for progress updates
// //       const ws = new WebSocket(
// //         `${process.env.REACT_APP_WS_URL}/ws/upload-status/?token=${token}`
// //       );

// //       wsRef.current = ws;

// //       // Step 2: Set up WebSocket message handler
// //       ws.onmessage = (e) => {
// //         const data = JSON.parse(e.data);
// //         console.log("WebSocket message received:", data);

// //         setFiles((prevFiles) => {
// //           let alreadyClaimed = false;

// //           const updatedFiles = prevFiles.map((f, i) => {
// //             const isKeyMatch = f.key === data.pdf_key;

// //             const canClaim =
// //               !alreadyClaimed &&
// //               !f.key &&
// //               f.status === STATUS.UPLOADING &&
// //               data.pdf_key &&
// //               !prevFiles.some(
// //                 (other, idx) => other.key === data.pdf_key && idx !== i
// //               );

// //             if (!isKeyMatch && !canClaim) return f;

// //             const patch = {};

// //             if (canClaim) {
// //               patch.key = data.pdf_key;
// //               alreadyClaimed = true;
// //             }

// //             if (data.type === "progress") {
// //               patch.progress = data.progress;
// //             } else if (data.type === "completed") {
// //               patch.status = STATUS.SUCCESS;
// //               patch.progress = 100;
// //               // Store file_id from metadata if available
// //               if (data.metadata?.file_id) {
// //                 patch.file_id = data.metadata.file_id;
// //               }
// //             } else if (data.type === "error") {
// //               patch.status = STATUS.ERROR;
// //               patch.progress = 0;
// //               const msg = data.message?.toLowerCase() || "";

// //               if (msg.includes("unsupported")) {
// //                 patch.errorReason = "unsupported";
// //               } else if (msg.includes("duplicate")) {
// //                 patch.errorReason = "duplicate";
// //               } else if (msg.includes("size") || msg.includes("limit")) {
// //                 patch.errorReason = "size_limit";
// //               } else {
// //                 patch.errorReason = "unknown";
// //               }
// //             }

// //             return { ...f, ...patch };
// //           });

// //           // Check if all files are done (either success or error)
// //           const allFilesDone = updatedFiles.every(
// //             (f) => f.status === STATUS.SUCCESS || f.status === STATUS.ERROR
// //           );

// //           if (allFilesDone) {
// //             if (ws.readyState === WebSocket.OPEN) {
// //               ws.close();
// //             }
// //             setIsUploadingFiles(false);

// //             finalizeProjectCreation(updatedFiles);
// //           }

// //           return updatedFiles;
// //         });
// //       };

// //       ws.onerror = (error) => {
// //         console.error("WebSocket error:", error);
// //         setFiles((prev) =>
// //           prev.map((f) =>
// //             f.status === STATUS.UPLOADING
// //               ? {
// //                   ...f,
// //                   status: STATUS.ERROR,
// //                   errorReason: "websocket_error",
// //                 }
// //               : f
// //           )
// //         );
// //         setIsUploadingFiles(false);
// //         setLoading(false);
// //         setButtonText("Create Project");
// //         toast.error("WebSocket connection failed.");
// //       };

// //       // Step 3: Once WebSocket is open, send HTTP POST with files + metadata
// //       ws.onopen = async () => {
// //         console.log("WebSocket connected, creating folder with files...");

// //         try {
// //           // Create FormData with files AND metadata
// //           const formData = new FormData();

// //           // Append project name and description
// //           formData.append("folder_name", projectName.trim());
// //           formData.append("description", description.trim());

// //           // Append ONLY files that are not already errors (and preferably not already success)
// //           // Typically we append the files we intend to upload
// //           files.forEach((fileObj) => {
// //              // Only append files that are NOT already in ERROR state
// //              if (fileObj.status !== STATUS.ERROR) {
// //                 formData.append("files", fileObj.file);
// //              }
// //           });

// //           // Make HTTP POST request to create folder with files
// //           const url = `${process.env.REACT_APP_API_URL}api/v1/rfp/create-folder/`;

// //           const resp = await api.post(url, formData, {
// //             headers: { "Content-Type": "multipart/form-data" },
// //             onUploadProgress: (ev) => {
// //               // Initial network upload progress (0-30%)
// //               const baseProgress = Math.min(
// //                 30,
// //                 Math.round((ev.loaded * 100) / ev.total)
// //               );
// //               setFiles((prev) =>
// //                 prev.map((f) => {
// //                   if (f.status === STATUS.UPLOADING) {
// //                     return {
// //                       ...f,
// //                       progress: Math.max(f.progress, baseProgress),
// //                     };
// //                   }
// //                   return f;
// //                 })
// //               );
// //             },
// //           });

// //           console.log("Folder creation response:", resp.data);

// //           // Get uploads response with pdf_keys
// //           const uploads = resp.data?.uploads || [];

// //           // Match pdf_keys to files by filename
// //           setFiles((prevFiles) =>
// //             prevFiles.map((f) => {
// //               const upload = uploads.find((u) => u.filename === f.file.name);
// //               return upload && upload.pdf_key
// //                 ? { ...f, key: upload.pdf_key }
// //                 : f;
// //             })
// //           );
// //         } catch (err) {
// //           console.error("🚨 Folder creation failed:", err);
// //           setFiles((prev) =>
// //             prev.map((f) =>
// //               f.status === STATUS.UPLOADING
// //                 ? {
// //                     ...f,
// //                     status: STATUS.ERROR,
// //                     errorReason: "upload_failed",
// //                   }
// //                 : f
// //             )
// //           );

// //           if (ws.readyState === WebSocket.OPEN) {
// //             ws.close();
// //           }
// //           setIsUploadingFiles(false);
// //           setLoading(false);
// //           setButtonText("Create Project");

// //           const backendMsg =
// //             err?.response?.data?.msg ||
// //             err?.response?.data?.error ||
// //             "Failed to create folder. Please try again.";

// //           // Handle specific errors
// //           if (
// //             backendMsg.toLowerCase().includes("folder name already exists") ||
// //             backendMsg.toLowerCase().includes("name already exists")
// //           ) {
// //             toast.error(backendMsg);
// //           } else if (
// //             backendMsg === "Only 5 files allowed" ||
// //             backendMsg.includes("Trial users can upload only 5 documents")
// //           ) {
// //             toast.error(backendMsg);
// //           } else {
// //             toast.error(backendMsg);
// //           }
// //         }
// //       };
// //     } catch (error) {
// //       console.error("Error setting up folder creation:", error);
// //       setFiles((prev) =>
// //         prev.map((f) => ({
// //           ...f,
// //           status: STATUS.ERROR,
// //           errorReason: "setup_error",
// //         }))
// //       );
// //       setIsUploadingFiles(false);
// //       setLoading(false);
// //       setButtonText("Create Project");
// //       toast.error("Failed to initiate folder creation.");
// //     }
// //   };

// //   const finalizeProjectCreation = async (uploadedFiles) => {
// //     setButtonText("Finalizing...");

// //     try {
// //       // Get successfully uploaded file IDs
// //       // This automatically ignores failed files
// //       const uploadedFileIds = uploadedFiles
// //         .filter((file) => file.status === STATUS.SUCCESS && file.file_id)
// //         .map((file) => file.file_id);

// //       // Call parent component callback with project data
// //       if (onCreateProject) {
// //         await onCreateProject({
// //           projectName: projectName.trim(),
// //           description: description.trim(),
// //           fileIds: uploadedFileIds,
// //         });
// //       }

// //       // Show success state in button
// //       setButtonText("Create Project");
// //       setIsSuccess(true);
// //       setLoading(false);

// //       // Wait for 2 seconds before closing the modal
// //       successTimeoutRef.current = setTimeout(() => {
// //         handleClose();
// //       }, 500);
// //     } catch (error) {
// //       console.error("Error finalizing project:", error);
// //       setButtonText("Create Project");
// //       setIsSuccess(false);
// //       setLoading(false);

// //       const errorMessage =
// //         error?.response?.data?.error ||
// //         error.message ||
// //         "Failed to finalize project. Please try again.";
// //       toast.error(errorMessage);
// //     }
// //   };

// //   const handleDragOver = (e) => {
// //     e.preventDefault();
// //   };

// //   const handleDrop = (e) => {
// //     e.preventDefault();
// //     e.stopPropagation();
// //     handleFileChange(e);
// //   };

// //   const removeFile = (indexToRemove) => {
// //     setFiles((prev) => prev.filter((_, index) => index !== indexToRemove));
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     if (!projectName.trim()) {
// //       toast.error("Please enter a project name.");
// //       return;
// //     }

// //     // Check if files are still uploading
// //     if (isUploadingFiles) {
// //       toast.error("Please wait for file uploads to complete.");
// //       return;
// //     }

// //     // REMOVED: The check for failedUploads.length > 0 has been removed.
// //     // We now proceed to createFolderWithFiles even if there are errors.
    
// //     // Start folder creation with files
// //     await createFolderWithFiles();
// //   };

// //   const handleClose = () => {
// //     // Clear any pending timeout
// //     if (successTimeoutRef.current) {
// //       clearTimeout(successTimeoutRef.current);
// //       successTimeoutRef.current = null;
// //     }

// //     // Close WebSocket connection
// //     if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
// //       wsRef.current.close();
// //     }

// //     // Reset all states
// //     setProjectName("");
// //     setDescription("");
// //     setFiles([]);
// //     setLoading(false);
// //     setButtonText("Create Project");
// //     setIsSuccess(false);
// //     setIsUploadingFiles(false);

// //     // Close modal
// //     onClose();
// //   };

// //   // Helper function to get file extension
// //   const getFileExtension = (filename) => {
// //     return filename.split(".").pop().toLowerCase();
// //   };

// //   // Helper function to format file size
// //   const formatFileSize = (bytes) => {
// //     if (bytes < 1024) return bytes + " B";
// //     else if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + " KB";
// //     else return (bytes / (1024 * 1024)).toFixed(2) + " MB";
// //   };

// //   const getFileIcon = (filename) => {
// //     const ext = getFileExtension(filename);

// //     if (ext === "pdf") {
// //       return <img src={pdfImg} alt="PDF" className="w-8 h-10 flex-shrink-0" />;
// //     } else if (ext === "xls" || ext === "xlsx" || ext === "csv") {
// //       return (
// //         <img src={xlsImg} alt="Excel" className="w-8 h-10 flex-shrink-0" />
// //       );
// //     } else if (ext === "doc" || ext === "docx") {
// //       return <img src={docImg} alt="Word" className="w-8 h-10 flex-shrink-0" />;
// //     } else {
// //       return (
// //         <img src={docImg} alt="Document" className="w-8 h-10 flex-shrink-0" />
// //       );
// //     }
// //   };

// //   // Check if we can create project
// //   const canCreateProject =
// //     projectName.trim().length > 0 && 
// //     !loading &&
// //     !isUploadingFiles;

// //   const canAddMoreFiles = true;

// //   if (!isOpen) return null;

// //   return (
// //     <div
// //       className="fixed inset-0 z-[10050] flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm"
// //       onClick={handleClose}
// //     >
// //       <div
// //         className="bg-white rounded-xl shadow-2xl px-6 py-4 w-[90%] max-w-lg relative"
// //         onClick={(e) => e.stopPropagation()}
// //         aria-modal="true"
// //         role="dialog"
// //       >
// //         {/* Header */}
// //         <div className="flex justify-between items-center mb-2">
// //           <h2 className="text-xl font-semibold text-gray-800 font-[Outfit]">
// //             Create New Project
// //           </h2>
// //           <button
// //             onClick={handleClose}
// //             className="text-[#52525BE3] hover:text-gray-600 transition"
// //             aria-label="Close"
// //             disabled={loading || isUploadingFiles}
// //           >
// //             <svg
// //               xmlns="http://www.w3.org/2000/svg"
// //               width="24"
// //               height="24"
// //               viewBox="0 0 24 24"
// //               fill="none"
// //               stroke="currentColor"
// //               strokeWidth="2"
// //               strokeLinecap="round"
// //               strokeLinejoin="round"
// //               className="w-6 h-6"
// //             >
// //               <line x1="18" y1="6" x2="6" y2="18"></line>
// //               <line x1="6" y1="6" x2="18" y2="18"></line>
// //             </svg>
// //           </button>
// //         </div>

// //         <p className="text-sm text-gray-500 mb-4 font-[Outfit]">
// //           Set up a new project, add files and share with your team easily.
// //         </p>

// //         <form onSubmit={handleSubmit}>

// //           <div className="mb-4">
// //             <label
// //               htmlFor="projectName"
// //               className="block text-[14px] font-medium !text-[#3F3F46] font-[Outfit] mb-1"
// //             >
// //               Project Name <span className="text-red-500">*</span>
// //             </label>
// //             <input
// //               id="projectName"
// //               type="text"
// //               value={projectName}
// //               onChange={(e) => setProjectName(e.target.value)}
// //               placeholder="Enter Project Name"
// //               className="w-full px-2 py-2 h-10 border border-gray-300 rounded-lg !font-normal placeholder-[#52525BE3] font-[Outfit] transition"
// //               required
// //               disabled={loading || isSuccess}
// //             />
// //           </div>

       
// //           <div className="mb-4">
// //             <label
// //               htmlFor="description"
// //               className="block text-[14px] font-medium !text-[#3F3F46] font-[Outfit] mb-1"
// //             >
// //               Description (Optional)
// //             </label>
// //             <textarea
// //               id="description"
// //               value={description}
// //               onChange={(e) => setDescription(e.target.value)}
// //               placeholder="Add Project Description..."
// //               rows="2"
// //               className="w-full px-2 py-2 border border-gray-300 rounded-lg placeholder-[#52525BE3] font-[Outfit] resize-none transition focus:outline-none focus:ring-0 focus:border-gray-300"
// //               disabled={loading || isSuccess}
// //             />
// //           </div>

      
// //           {/* <div className="mb-6">
// //             <div className="flex items-center justify-between mb-2">
// //               <label className="block text-[14px] font-medium !text-[#3F3F46] font-[Outfit]">
// //                 Selected Files ({files.length})
// //               </label>
// //               {canAddMoreFiles && !isSuccess && (
// //                 <button
// //                   type="button"
// //                   onClick={() =>
// //                     !loading &&
// //                     !isUploadingFiles &&
// //                     !isSuccess &&
// //                     document.getElementById("file-upload-input").click()
// //                   }
// //                   className="text-[#C95EBE] text-sm font-medium font-[Outfit] hover:underline"
// //                   disabled={loading || isUploadingFiles || isSuccess}
// //                 >
// //                   Add Files
// //                 </button>
// //               )}
// //             </div>

// //             <input
// //               id="file-upload-input"
// //               ref={fileInputRef}
// //               type="file"
// //               className="hidden"
// //               onChange={handleFileChange}
// //               accept=".pdf,.docx,.doc,.txt,.csv,.xls,.xlsx,.jpg,.jpeg,.png"
// //               multiple
// //               disabled={
// //                 loading || isUploadingFiles || isSuccess
// //               }
// //             />

// //             {files.length > 0 ? (
// //               <div className="space-y-3 max-h-[250px] overflow-y-auto pr-2 custom-scrollbar">
// //                 {files.map((fileObj, index) => (
// //                   <div
// //                     key={`${fileObj.file.name}-${index}`}
// //                     className="border border-gray-200 rounded-lg p-2"
// //                   >
// //                     <div className="flex items-center gap-3">
                 
// //                       {getFileIcon(fileObj.file.name)}

// //                       <div className="flex-1 min-w-0">
// //                         <p className="text-sm font-medium text-[#171717] truncate font-[Outfit]">
// //                           {fileObj.file.name}
// //                         </p>
// //                         <p className="text-xs text-gray-500 font-[Outfit]">
// //                           {formatFileSize(fileObj.file.size)}
// //                         </p>
// //                       </div>

// //                       <div className="flex-shrink-0">
// //                         {fileObj.status === STATUS.SUCCESS ? (
// //                           <CheckIcon />
// //                         ) : fileObj.status === STATUS.ERROR ? (
// //                           <ErrorIcon />
// //                         ) : fileObj.status === STATUS.UPLOADING ? (
// //                           <span className="text-sm font-semibold text-gray-800">
// //                             {Math.round(fileObj.progress)}%
// //                           </span>
// //                         ) : !isSuccess ? (
// //                           <button
// //                             type="button"
// //                             onClick={() => removeFile(index)}
// //                             className="text-gray-400 hover:text-gray-600 transition"
// //                             disabled={loading || isSuccess}
// //                           >
// //                             <svg
// //                               xmlns="http://www.w3.org/2000/svg"
// //                               width="20"
// //                               height="20"
// //                               viewBox="0 0 24 24"
// //                               fill="none"
// //                               stroke="currentColor"
// //                               strokeWidth="2"
// //                               strokeLinecap="round"
// //                               strokeLinejoin="round"
// //                             >
// //                               <line x1="18" y1="6" x2="6" y2="18"></line>
// //                               <line x1="6" y1="6" x2="18" y2="18"></line>
// //                             </svg>
// //                           </button>
// //                         ) : null}
// //                       </div>
// //                     </div>

// //                     {(fileObj.status === STATUS.UPLOADING ||
// //                       fileObj.status === STATUS.SUCCESS ||
// //                       fileObj.status === STATUS.ERROR) && (
// //                       <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-gray-200">
// //                         <div
// //                           className={`h-2 rounded-full transition-all duration-300 ease-linear ${
// //                             fileObj.status === STATUS.ERROR
// //                               ? "bg-red-500"
// //                               : fileObj.status === STATUS.SUCCESS
// //                               ? "bg-green-500"
// //                               : "bg-purple-600"
// //                           }`}
// //                           style={{
// //                             width: `${fileObj.progress}%`,
// //                             background:
// //                               fileObj.status === STATUS.UPLOADING
// //                                 ? "linear-gradient(180deg, #C95EBE 0%, #8B55DD 100%)"
// //                                 : undefined,
// //                           }}
// //                         ></div>
// //                       </div>
// //                     )}

// //                     {fileObj.status === STATUS.ERROR && (
// //                       <p className="mt-1 text-xs text-red-600">
// //                         {fileObj.errorReason === "unsupported"
// //                           ? "Unsupported file type"
// //                           : fileObj.errorReason === "duplicate"
// //                           ? "Duplicate file"
// //                           : fileObj.errorReason === "size_limit"
// //                           ? "File size exceeds limit"
// //                           : "Upload failed"}
// //                       </p>
// //                     )}
// //                   </div>
// //                 ))}
// //               </div>
// //             ) : (
// //               <div
// //                 className={`border-1 border-[#E5E9FF] bg-[#FAF7FF] rounded-lg p-8 text-center cursor-pointer transition ${
// //                   loading || isUploadingFiles || isSuccess
// //                     ? "opacity-50 cursor-not-allowed"
// //                     : "hover:bg-purple-50"
// //                 }`}
// //                 onDragOver={handleDragOver}
// //                 onDrop={!isSuccess ? handleDrop : undefined}
// //                 onClick={() =>
// //                   !loading &&
// //                   !isUploadingFiles &&
// //                   !isSuccess &&
// //                   document.getElementById("file-upload-input").click()
// //                 }
// //               >
// //                 <div className="text-[#BB42AE] mb-2">
// //                   <svg
// //                     xmlns="http://www.w3.org/2000/svg"
// //                     width="30"
// //                     height="30"
// //                     viewBox="0 0 24 24"
// //                     fill="none"
// //                     stroke="currentColor"
// //                     strokeWidth="1.5"
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                     className="mx-auto"
// //                   >
// //                     <path d="M4 14.899V20c0 .552.448 1 1 1h14c.552 0 1-.448 1-1v-5.101M12 3v13.5M7.5 7.5l4.5-4.5 4.5 4.5" />
// //                   </svg>
// //                 </div>
// //                 <p className="text-gray-600 font-medium font-[Outfit]">
// //                   Drag & drop files here or click to upload.
// //                 </p>
// //                 <p className="text-xs text-[#52525BE3] mt-1 font-[Outfit]">
// //                   Max 25 MB each, supported formats: PDF, DOCX, XLS
// //                 </p>
// //               </div>
// //             )}
// //           </div> */}

        
// //           <div className="flex justify-center gap-3">
// //             <button
// //               type="button"
// //               onClick={handleClose}
// //               className="w-[20%] py-2 rounded-[8px] text-[#C95EBE] bg-white border border-[#C95EBE] font-medium font-[Outfit] transition disabled:opacity-50"
// //               disabled={loading || isUploadingFiles}
// //             >
// //               Cancel
// //             </button>
// //             <button
// //               type="submit"
// //               className={`w-[38%] py-2 rounded-[8px] text-white font-medium font-[Outfit] transition flex items-center justify-center min-w-[150px] ${
// //                 isSuccess
// //                   ? "bg-[#C95EBE]"
// //                   : !projectName.trim() 
// //                   ? "bg-gray-400 cursor-not-allowed"
// //                   : "bg-[#C95EBE] hover:bg-[#b54eb0]"
// //               }`}
// //               disabled={!canCreateProject || !projectName.trim()} 
// //             >
// //               {buttonText}
// //             </button>
// //           </div>
// //         </form>
// //       </div>
// //     </div>
// //   );
// // };

// // // Icons
// // const CheckIcon = () => (
// //   <svg
// //     width="24"
// //     height="24"
// //     viewBox="0 0 24 24"
// //     fill="none"
// //     xmlns="http://www.w3.org/2000/svg"
// //   >
// //     <path
// //       d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
// //       fill="#22C55E"
// //     />
// //   </svg>
// // );

// // const ErrorIcon = () => (
// //   <svg
// //     width="24"
// //     height="24"
// //     viewBox="0 0 24 24"
// //     fill="none"
// //     xmlns="http://www.w3.org/2000/svg"
// //   >
// //     <path
// //       d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
// //       fill="#EF4444"
// //     />
// //   </svg>
// // );

// // export default CreateProjectModal;



// import React, { useState, useEffect, useRef } from "react";
// import { getFreshAccessToken } from "../../chat/api";
// import api from "../../chat/api";
// import { toast } from "react-toastify";
// import pdfImg from "./pdf.png";
// import xlsImg from "./xls.png";
// import docImg from "./doc.png";
// import { CloseIcon, RemoveIcon, UploadIcon, CheckIcon, ErrorIcon } from "./Svgs";

// const CreateProjectModal = ({ isOpen, onClose, onCreateProject }) => {
//   const [projectName, setProjectName] = useState("");
//   const [description, setDescription] = useState("");
//   const [files, setFiles] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [buttonText, setButtonText] = useState("Create Project");
//   const [isSuccess, setIsSuccess] = useState(false);
//   const [isUploadingFiles, setIsUploadingFiles] = useState(false);
//   const maxFileSizeMB = 25;

//   const STATUS = {
//     PENDING: "pending",
//     UPLOADING: "uploading",
//     SUCCESS: "success",
//     ERROR: "error",
//   };

//   const wsRef = useRef(null);
//   const fileInputRef = useRef(null);
//   const successTimeoutRef = useRef(null);

//   useEffect(() => {
//     if (!isOpen) {
//       if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
//         wsRef.current.close();
//       }
//       if (successTimeoutRef.current) {
//         clearTimeout(successTimeoutRef.current);
//         successTimeoutRef.current = null;
//       }

//       setProjectName("");
//       setDescription("");
//       setFiles([]);
//       setLoading(false);
//       setButtonText("Create Project");
//       setIsSuccess(false);
//       setIsUploadingFiles(false);
//     }
//   }, [isOpen]);

//   useEffect(() => {
//     return () => {
//       if (successTimeoutRef.current) {
//         clearTimeout(successTimeoutRef.current);
//       }
//     };
//   }, []);

//   const handleFileChange = (e) => {
//     const selectedFiles = e.target.files
//       ? Array.from(e.target.files)
//       : Array.from(e.dataTransfer.files);

//     const validFiles = [];

//     selectedFiles.forEach((file) => {
//       if (file.size > maxFileSizeMB * 1024 * 1024) {
//         toast.error(
//           `File ${file.name} exceeds the maximum limit of ${maxFileSizeMB} MB.`
//         );
//         return;
//       }

//       if (!files.some((f) => f.file && f.file.name === file.name)) {
//         validFiles.push({
//           file,
//           progress: 0,
//           status: STATUS.PENDING,
//           errorReason: null,
//           key: null,
//           file_id: null,
//         });
//       } else {
//         toast.error(`File ${file.name} is already added.`);
//       }
//     });

//     if (validFiles.length > 0) {
//       setFiles((prev) => [...prev, ...validFiles]);
//     }

//     // Reset file input to allow re-selecting same file
//     if (fileInputRef.current) {
//       fileInputRef.current.value = null;
//     }
//   };

//   // Create folder with files - triggered on button click
//   const createFolderWithFiles = async () => {
//     setIsUploadingFiles(true);
//     setLoading(true);
//     setButtonText("Creating Project...");

//     // Update all pending files to uploading status
//     setFiles((prev) =>
//       prev.map((f) =>
//         f.status === STATUS.PENDING ? { ...f, status: STATUS.UPLOADING } : f
//       )
//     );
    
//     const filesToUpload = files.filter(f => f.status !== STATUS.ERROR);
//     try {
//       const token = await getFreshAccessToken();

//       // Step 1: Open WebSocket connection for progress updates
//       const ws = new WebSocket(
//         `${process.env.REACT_APP_WS_URL}/ws/upload-status/?token=${token}`
//       );

//       wsRef.current = ws;

//       // Step 2: Set up WebSocket message handler
//       ws.onmessage = (e) => {
//         const data = JSON.parse(e.data);
//         console.log("WebSocket message received:", data);

//         setFiles((prevFiles) => {
//           let alreadyClaimed = false;

//           const updatedFiles = prevFiles.map((f, i) => {
//             const isKeyMatch = f.key === data.pdf_key;

//             const canClaim =
//               !alreadyClaimed &&
//               !f.key &&
//               f.status === STATUS.UPLOADING &&
//               data.pdf_key &&
//               !prevFiles.some(
//                 (other, idx) => other.key === data.pdf_key && idx !== i
//               );

//             if (!isKeyMatch && !canClaim) return f;

//             const patch = {};

//             if (canClaim) {
//               patch.key = data.pdf_key;
//               alreadyClaimed = true;
//             }

//             if (data.type === "progress") {
//               patch.progress = data.progress;
//             } else if (data.type === "completed") {
//               patch.status = STATUS.SUCCESS;
//               patch.progress = 100;
//               // Store file_id from metadata if available
//               if (data.metadata?.file_id) {
//                 patch.file_id = data.metadata.file_id;
//               }
//             } else if (data.type === "error") {
//               patch.status = STATUS.ERROR;
//               patch.progress = 0;
//               const msg = data.message?.toLowerCase() || "";

//               if (msg.includes("unsupported")) {
//                 patch.errorReason = "unsupported";
//               } else if (msg.includes("duplicate")) {
//                 patch.errorReason = "duplicate";
//               } else if (msg.includes("size") || msg.includes("limit")) {
//                 patch.errorReason = "size_limit";
//               } else {
//                 patch.errorReason = "unknown";
//               }
//             }

//             return { ...f, ...patch };
//           });

//           // Check if all files are done (either success or error)
//           const allFilesDone = updatedFiles.every(
//             (f) => f.status === STATUS.SUCCESS || f.status === STATUS.ERROR
//           );

//           if (allFilesDone) {
//             if (ws.readyState === WebSocket.OPEN) {
//               ws.close();
//             }
//             setIsUploadingFiles(false);

//             finalizeProjectCreation(updatedFiles);
//           }

//           return updatedFiles;
//         });
//       };

//       ws.onerror = (error) => {
//         console.error("WebSocket error:", error);
//         setFiles((prev) =>
//           prev.map((f) =>
//             f.status === STATUS.UPLOADING
//               ? {
//                   ...f,
//                   status: STATUS.ERROR,
//                   errorReason: "websocket_error",
//                 }
//               : f
//           )
//         );
//         setIsUploadingFiles(false);
//         setLoading(false);
//         setButtonText("Create Project");
//         toast.error("WebSocket connection failed.");
//       };

//       // Step 3: Once WebSocket is open, send HTTP POST with files + metadata
//       ws.onopen = async () => {
//         console.log("WebSocket connected, creating folder with files...");

//         try {
//           // Create FormData with files AND metadata
//           const formData = new FormData();

//           // Append project name and description
//           formData.append("folder_name", projectName.trim());
//           formData.append("description", description.trim());

//           // Append ONLY files that are not already errors (and preferably not already success)
//           // Typically we append the files we intend to upload
//           files.forEach((fileObj) => {
//              // Only append files that are NOT already in ERROR state
//              if (fileObj.status !== STATUS.ERROR) {
//                 formData.append("files", fileObj.file);
//              }
//           });

//           // Make HTTP POST request to create folder with files
//           const url = `${process.env.REACT_APP_API_URL}api/v1/rfp/create-folder/`;

//           const resp = await api.post(url, formData, {
//             headers: { "Content-Type": "multipart/form-data" },
//             onUploadProgress: (ev) => {
//               // Initial network upload progress (0-30%)
//               const baseProgress = Math.min(
//                 30,
//                 Math.round((ev.loaded * 100) / ev.total)
//               );
//               setFiles((prev) =>
//                 prev.map((f) => {
//                   if (f.status === STATUS.UPLOADING) {
//                     return {
//                       ...f,
//                       progress: Math.max(f.progress, baseProgress),
//                     };
//                   }
//                   return f;
//                 })
//               );
//             },
//           });

//           console.log("Folder creation response:", resp.data);

//           // Get uploads response with pdf_keys
//           const uploads = resp.data?.uploads || [];

//           // Match pdf_keys to files by filename
//           setFiles((prevFiles) =>
//             prevFiles.map((f) => {
//               const upload = uploads.find((u) => u.filename === f.file.name);
//               return upload && upload.pdf_key
//                 ? { ...f, key: upload.pdf_key }
//                 : f;
//             })
//           );
//         } catch (err) {
//           console.error("🚨 Folder creation failed:", err);
//           setFiles((prev) =>
//             prev.map((f) =>
//               f.status === STATUS.UPLOADING
//                 ? {
//                     ...f,
//                     status: STATUS.ERROR,
//                     errorReason: "upload_failed",
//                   }
//                 : f
//             )
//           );

//           if (ws.readyState === WebSocket.OPEN) {
//             ws.close();
//           }
//           setIsUploadingFiles(false);
//           setLoading(false);
//           setButtonText("Create Project");

//           const backendMsg =
//             err?.response?.data?.msg ||
//             err?.response?.data?.error ||
//             "Failed to create folder. Please try again.";

//           // Handle specific errors
//           if (
//             backendMsg.toLowerCase().includes("folder name already exists") ||
//             backendMsg.toLowerCase().includes("name already exists")
//           ) {
//             toast.error(backendMsg);
//           } else if (
//             backendMsg === "Only 5 files allowed" ||
//             backendMsg.includes("Trial users can upload only 5 documents")
//           ) {
//             toast.error(backendMsg);
//           } else {
//             toast.error(backendMsg);
//           }
//         }
//       };
//     } catch (error) {
//       console.error("Error setting up folder creation:", error);
//       setFiles((prev) =>
//         prev.map((f) => ({
//           ...f,
//           status: STATUS.ERROR,
//           errorReason: "setup_error",
//         }))
//       );
//       setIsUploadingFiles(false);
//       setLoading(false);
//       setButtonText("Create Project");
//       toast.error("Failed to initiate folder creation.");
//     }
//   };

//   const finalizeProjectCreation = async (uploadedFiles) => {
//     setButtonText("Finalizing...");

//     try {
//       // Get successfully uploaded file IDs
//       // This automatically ignores failed files
//       const uploadedFileIds = uploadedFiles
//         .filter((file) => file.status === STATUS.SUCCESS && file.file_id)
//         .map((file) => file.file_id);

//       // Call parent component callback with project data
//       if (onCreateProject) {
//         await onCreateProject({
//           projectName: projectName.trim(),
//           description: description.trim(),
//           fileIds: uploadedFileIds,
//         });
//       }

//       // Show success state in button
//       setButtonText("Create Project");
//       setIsSuccess(true);
//       setLoading(false);

//       // Wait for 2 seconds before closing the modal
//       successTimeoutRef.current = setTimeout(() => {
//         handleClose();
//       }, 500);
//     } catch (error) {
//       console.error("Error finalizing project:", error);
//       setButtonText("Create Project");
//       setIsSuccess(false);
//       setLoading(false);

//       const errorMessage =
//         error?.response?.data?.error ||
//         error.message ||
//         "Failed to finalize project. Please try again.";
//       toast.error(errorMessage);
//     }
//   };

//   const handleDragOver = (e) => {
//     e.preventDefault();
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     handleFileChange(e);
//   };

//   const removeFile = (indexToRemove) => {
//     setFiles((prev) => prev.filter((_, index) => index !== indexToRemove));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!projectName.trim()) {
//       toast.error("Please enter a project name.");
//       return;
//     }

//     // Check if files are still uploading
//     if (isUploadingFiles) {
//       toast.error("Please wait for file uploads to complete.");
//       return;
//     }

//     // REMOVED: The check for failedUploads.length > 0 has been removed.
//     // We now proceed to createFolderWithFiles even if there are errors.
    
//     // Start folder creation with files
//     await createFolderWithFiles();
//   };

//   const handleClose = () => {
//     // Clear any pending timeout
//     if (successTimeoutRef.current) {
//       clearTimeout(successTimeoutRef.current);
//       successTimeoutRef.current = null;
//     }

//     // Close WebSocket connection
//     if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
//       wsRef.current.close();
//     }

//     // Reset all states
//     setProjectName("");
//     setDescription("");
//     setFiles([]);
//     setLoading(false);
//     setButtonText("Create Project");
//     setIsSuccess(false);
//     setIsUploadingFiles(false);

//     // Close modal
//     onClose();
//   };

//   // Helper function to get file extension
//   const getFileExtension = (filename) => {
//     return filename.split(".").pop().toLowerCase();
//   };

//   // Helper function to format file size
//   const formatFileSize = (bytes) => {
//     if (bytes < 1024) return bytes + " B";
//     else if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + " KB";
//     else return (bytes / (1024 * 1024)).toFixed(2) + " MB";
//   };

//   const getFileIcon = (filename) => {
//     const ext = getFileExtension(filename);

//     if (ext === "pdf") {
//       return <img src={pdfImg} alt="PDF" className="w-8 h-10 flex-shrink-0" />;
//     } else if (ext === "xls" || ext === "xlsx" || ext === "csv") {
//       return (
//         <img src={xlsImg} alt="Excel" className="w-8 h-10 flex-shrink-0" />
//       );
//     } else if (ext === "doc" || ext === "docx") {
//       return <img src={docImg} alt="Word" className="w-8 h-10 flex-shrink-0" />;
//     } else {
//       return (
//         <img src={docImg} alt="Document" className="w-8 h-10 flex-shrink-0" />
//       );
//     }
//   };

//   // Check if we can create project
//   const canCreateProject =
//     projectName.trim().length > 0 && 
//     !loading &&
//     !isUploadingFiles;

//   const canAddMoreFiles = true;

//   if (!isOpen) return null;

//   return (
//     <div
//       className="fixed inset-0 z-[10050] flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm"
//       onClick={handleClose}
//     >
//       <div
//         className="bg-white rounded-xl shadow-2xl px-6 py-4 w-[90%] max-w-lg relative"
//         onClick={(e) => e.stopPropagation()}
//         aria-modal="true"
//         role="dialog"
//       >
//         {/* Header */}
//         <div className="flex justify-between items-center mb-2">
//           <h2 className="text-xl font-semibold text-gray-800 font-[Outfit]">
//             Create New Project
//           </h2>
//           <button
//             onClick={handleClose}
//             className="text-[#52525BE3] hover:text-gray-600 transition"
//             aria-label="Close"
//             disabled={loading || isUploadingFiles}
//           >
//             <CloseIcon className="w-6 h-6" />
//           </button>
//         </div>

//         <p className="text-sm text-gray-500 mb-4 font-[Outfit]">
//           Set up a new project, add files and share with your team easily.
//         </p>

//         <form onSubmit={handleSubmit}>

//           <div className="mb-4">
//             <label
//               htmlFor="projectName"
//               className="block text-[14px] font-medium !text-[#3F3F46] font-[Outfit] mb-1"
//             >
//               Project Name <span className="text-red-500">*</span>
//             </label>
//             <input
//               id="projectName"
//               type="text"
//               value={projectName}
//               onChange={(e) => setProjectName(e.target.value)}
//               placeholder="Enter Project Name"
//               className="w-full px-2 py-2 h-10 border border-gray-300 rounded-lg !font-normal placeholder-[#52525BE3] font-[Outfit] transition"
//               required
//               disabled={loading || isSuccess}
//             />
//           </div>

       
//           <div className="mb-4">
//             <label
//               htmlFor="description"
//               className="block text-[14px] font-medium !text-[#3F3F46] font-[Outfit] mb-1"
//             >
//               Description (Optional)
//             </label>
//             <textarea
//               id="description"
//               value={description}
//               onChange={(e) => setDescription(e.target.value)}
//               placeholder="Add Project Description..."
//               rows="2"
//               className="w-full px-2 py-2 border border-gray-300 rounded-lg placeholder-[#52525BE3] font-[Outfit] resize-none transition focus:outline-none focus:ring-0 focus:border-gray-300"
//               disabled={loading || isSuccess}
//             />
//           </div>

      
//           {/* <div className="mb-6">
//             <div className="flex items-center justify-between mb-2">
//               <label className="block text-[14px] font-medium !text-[#3F3F46] font-[Outfit]">
//                 Selected Files ({files.length})
//               </label>
//               {canAddMoreFiles && !isSuccess && (
//                 <button
//                   type="button"
//                   onClick={() =>
//                     !loading &&
//                     !isUploadingFiles &&
//                     !isSuccess &&
//                     document.getElementById("file-upload-input").click()
//                   }
//                   className="text-[#C95EBE] text-sm font-medium font-[Outfit] hover:underline"
//                   disabled={loading || isUploadingFiles || isSuccess}
//                 >
//                   Add Files
//                 </button>
//               )}
//             </div>

//             <input
//               id="file-upload-input"
//               ref={fileInputRef}
//               type="file"
//               className="hidden"
//               onChange={handleFileChange}
//               accept=".pdf,.docx,.doc,.txt,.csv,.xls,.xlsx,.jpg,.jpeg,.png"
//               multiple
//               disabled={
//                 loading || isUploadingFiles || isSuccess
//               }
//             />

//             {files.length > 0 ? (
//               <div className="space-y-3 max-h-[250px] overflow-y-auto pr-2 custom-scrollbar">
//                 {files.map((fileObj, index) => (
//                   <div
//                     key={`${fileObj.file.name}-${index}`}
//                     className="border border-gray-200 rounded-lg p-2"
//                   >
//                     <div className="flex items-center gap-3">
                 
//                       {getFileIcon(fileObj.file.name)}

//                       <div className="flex-1 min-w-0">
//                         <p className="text-sm font-medium text-[#171717] truncate font-[Outfit]">
//                           {fileObj.file.name}
//                         </p>
//                         <p className="text-xs text-gray-500 font-[Outfit]">
//                           {formatFileSize(fileObj.file.size)}
//                         </p>
//                       </div>

//                       <div className="flex-shrink-0">
//                         {fileObj.status === STATUS.SUCCESS ? (
//                           <CheckIcon />
//                         ) : fileObj.status === STATUS.ERROR ? (
//                           <ErrorIcon />
//                         ) : fileObj.status === STATUS.UPLOADING ? (
//                           <span className="text-sm font-semibold text-gray-800">
//                             {Math.round(fileObj.progress)}%
//                           </span>
//                         ) : !isSuccess ? (
//                           <button
//                             type="button"
//                             onClick={() => removeFile(index)}
//                             className="text-gray-400 hover:text-gray-600 transition"
//                             disabled={loading || isSuccess}
//                           >
//                             <RemoveIcon />
//                           </button>
//                         ) : null}
//                       </div>
//                     </div>

//                     {(fileObj.status === STATUS.UPLOADING ||
//                       fileObj.status === STATUS.SUCCESS ||
//                       fileObj.status === STATUS.ERROR) && (
//                       <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-gray-200">
//                         <div
//                           className={`h-2 rounded-full transition-all duration-300 ease-linear ${
//                             fileObj.status === STATUS.ERROR
//                               ? "bg-red-500"
//                               : fileObj.status === STATUS.SUCCESS
//                               ? "bg-green-500"
//                               : "bg-purple-600"
//                           }`}
//                           style={{
//                             width: `${fileObj.progress}%`,
//                             background:
//                               fileObj.status === STATUS.UPLOADING
//                                 ? "linear-gradient(180deg, #C95EBE 0%, #8B55DD 100%)"
//                                 : undefined,
//                           }}
//                         ></div>
//                       </div>
//                     )}

//                     {fileObj.status === STATUS.ERROR && (
//                       <p className="mt-1 text-xs text-red-600">
//                         {fileObj.errorReason === "unsupported"
//                           ? "Unsupported file type"
//                           : fileObj.errorReason === "duplicate"
//                           ? "Duplicate file"
//                           : fileObj.errorReason === "size_limit"
//                           ? "File size exceeds limit"
//                           : "Upload failed"}
//                       </p>
//                     )}
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <div
//                 className={`border-1 border-[#E5E9FF] bg-[#FAF7FF] rounded-lg p-8 text-center cursor-pointer transition ${
//                   loading || isUploadingFiles || isSuccess
//                     ? "opacity-50 cursor-not-allowed"
//                     : "hover:bg-purple-50"
//                 }`}
//                 onDragOver={handleDragOver}
//                 onDrop={!isSuccess ? handleDrop : undefined}
//                 onClick={() =>
//                   !loading &&
//                   !isUploadingFiles &&
//                   !isSuccess &&
//                   document.getElementById("file-upload-input").click()
//                 }
//               >
//                 <div className="text-[#BB42AE] mb-2">
//                   <UploadIcon className="mx-auto" />
//                 </div>
//                 <p className="text-gray-600 font-medium font-[Outfit]">
//                   Drag & drop files here or click to upload.
//                 </p>
//                 <p className="text-xs text-[#52525BE3] mt-1 font-[Outfit]">
//                   Max 25 MB each, supported formats: PDF, DOCX, XLS
//                 </p>
//               </div>
//             )}
//           </div> */}

        
//           <div className="flex justify-center gap-3">
//             <button
//               type="button"
//               onClick={handleClose}
//               className="w-[20%] py-2 rounded-[8px] text-[#C95EBE] bg-white border border-[#C95EBE] font-medium font-[Outfit] transition disabled:opacity-50"
//               disabled={loading || isUploadingFiles}
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className={`w-[38%] py-2 rounded-[8px] text-white font-medium font-[Outfit] transition flex items-center justify-center min-w-[150px] ${
//                 isSuccess
//                   ? "bg-[#C95EBE]"
//                   : !projectName.trim() 
//                   ? "bg-gray-400 cursor-not-allowed"
//                   : "bg-[#C95EBE] hover:bg-[#b54eb0]"
//               }`}
//               disabled={!canCreateProject || !projectName.trim()} 
//             >
//               {buttonText}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default CreateProjectModal;



import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getFreshAccessToken } from "../../chat/api";
import { markOnboarding } from "../../../onboarding/onboardingStore";
import api from "../../chat/api";
import { emitPlanLimit } from "../../../events/planLimitEvents";
import { quotaBlockedMessage } from "../../../services/rfpBillingApi";
import { toast } from "../../../utils/appToast";
import hotToast from "react-hot-toast";
import Cookies from "js-cookie";
import pdfImg from "./pdf.png";
import xlsImg from "./xls.png";
import docImg from "./doc.png";
import { CloseIcon, RemoveIcon, UploadIcon, CheckIcon, ErrorIcon } from "./Svgs";

const CreateProjectModal = ({ isOpen, onClose, onCreateProject }) => {
  const navigate = useNavigate();
  const [projectName, setProjectName] = useState("");
  const [description, setDescription] = useState("");
  const [webLinks, setWebLinks] = useState([]);
  const [linkInput, setLinkInput] = useState("");
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buttonText, setButtonText] = useState("Create Project");
  const [isSuccess, setIsSuccess] = useState(false);
  const [isUploadingFiles, setIsUploadingFiles] = useState(false);
  const maxFileSizeMB = 25;

  const STATUS = {
    PENDING: "pending",
    UPLOADING: "uploading",
    SUCCESS: "success",
    ERROR: "error",
  };

  const wsRef = useRef(null);
  const fileInputRef = useRef(null);
  const successTimeoutRef = useRef(null);
  const projectInfoRef = useRef(null); // Ref to hold the newly created project data
  const quotaCheckRef = useRef(null); // pending plan-limit check, started when the window opens

  useEffect(() => {
    if (!isOpen) {
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        wsRef.current.close();
      }
      if (successTimeoutRef.current) {
        clearTimeout(successTimeoutRef.current);
        successTimeoutRef.current = null;
      }

      setProjectName("");
      setDescription("");
      setWebLinks([]);
      setLinkInput("");
      setFiles([]);
      setLoading(false);
      setButtonText("Create Project");
      setIsSuccess(false);
      setIsUploadingFiles(false);
      projectInfoRef.current = null;
      quotaCheckRef.current = null;
      return;
    }
    // Asked as the window opens so the answer is ready when Create is clicked; at the plan
    // limit the server could otherwise only refuse after the whole upload had finished.
    quotaCheckRef.current = quotaBlockedMessage("projects");
  }, [isOpen]);

  useEffect(() => {
    return () => {
      if (successTimeoutRef.current) {
        clearTimeout(successTimeoutRef.current);
      }
    };
  }, []);

  const handleFileChange = (e) => {
    const selectedFiles = e.target.files
      ? Array.from(e.target.files)
      : Array.from(e.dataTransfer.files);

    const validFiles = [];

    selectedFiles.forEach((file) => {
      if (file.size > maxFileSizeMB * 1024 * 1024) {
        toast.error(
          `File ${file.name} exceeds the maximum limit of ${maxFileSizeMB} MB.`
        );
        return;
      }

      if (!files.some((f) => f.file && f.file.name === file.name)) {
        validFiles.push({
          file,
          progress: 0,
          status: STATUS.PENDING,
          errorReason: null,
          key: null,
          file_id: null,
        });
      } else {
        toast.error(`File ${file.name} is already added.`);
      }
    });

    if (validFiles.length > 0) {
      setFiles((prev) => [...prev, ...validFiles]);
    }

    // Reset file input to allow re-selecting same file
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  // Create folder with files - triggered on button click
  const createFolderWithFiles = async () => {
    setIsUploadingFiles(true);
    setLoading(true);
    setButtonText("Creating Project...");

    // Update all pending files to uploading status
    setFiles((prev) =>
      prev.map((f) =>
        f.status === STATUS.PENDING ? { ...f, status: STATUS.UPLOADING } : f
      )
    );
    
    const filesToUpload = files.filter(f => f.status !== STATUS.ERROR);
    try {
      const token = await getFreshAccessToken();

      // Step 1: Open WebSocket connection for progress updates
      const ws = new WebSocket(
        `${process.env.REACT_APP_WS_URL}/ws/upload-status/?token=${token}`
      );

      wsRef.current = ws;

      // Step 2: Set up WebSocket message handler
      ws.onmessage = (e) => {
        const data = JSON.parse(e.data);
        console.log("WebSocket message received:", data);

        setFiles((prevFiles) => {
          let alreadyClaimed = false;

          const updatedFiles = prevFiles.map((f, i) => {
            const isKeyMatch = f.key === data.pdf_key;

            const canClaim =
              !alreadyClaimed &&
              !f.key &&
              f.status === STATUS.UPLOADING &&
              data.pdf_key &&
              !prevFiles.some(
                (other, idx) => other.key === data.pdf_key && idx !== i
              );

            if (!isKeyMatch && !canClaim) return f;

            const patch = {};

            if (canClaim) {
              patch.key = data.pdf_key;
              alreadyClaimed = true;
            }

            if (data.type === "progress") {
              patch.progress = data.progress;
            } else if (data.type === "completed") {
              patch.status = STATUS.SUCCESS;
              patch.progress = 100;
              // Store file_id from metadata if available
              if (data.metadata?.file_id) {
                patch.file_id = data.metadata.file_id;
              }
            } else if (data.type === "error") {
              patch.status = STATUS.ERROR;
              patch.progress = 0;
              const msg = data.message?.toLowerCase() || "";

              if (msg.includes("unsupported")) {
                patch.errorReason = "unsupported";
              } else if (msg.includes("duplicate")) {
                patch.errorReason = "duplicate";
              } else if (msg.includes("size") || msg.includes("limit")) {
                patch.errorReason = "size_limit";
              } else {
                patch.errorReason = "unknown";
              }
            }

            return { ...f, ...patch };
          });

          // Check if all files are done (either success or error).
          // Guard against the empty-array case: [].every() returns true, which
          // would fire finalizeProjectCreation on the initial WS handshake
          // before the create-folder POST has populated projectInfoRef.
          const allFilesDone =
            updatedFiles.length > 0 &&
            updatedFiles.every(
              (f) => f.status === STATUS.SUCCESS || f.status === STATUS.ERROR
            );

          if (allFilesDone) {
            if (ws.readyState === WebSocket.OPEN) {
              ws.close();
            }
            setIsUploadingFiles(false);

            finalizeProjectCreation(updatedFiles);
          }

          return updatedFiles;
        });
      };

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
        setFiles((prev) =>
          prev.map((f) =>
            f.status === STATUS.UPLOADING
              ? {
                  ...f,
                  status: STATUS.ERROR,
                  errorReason: "websocket_error",
                }
              : f
          )
        );
        setIsUploadingFiles(false);
        setLoading(false);
        setButtonText("Create Project");
        toast.error("WebSocket connection failed.");
      };

      // Step 3: Once WebSocket is open, send HTTP POST with files + metadata
      ws.onopen = async () => {
        console.log("WebSocket connected, creating folder with files...");

        try {
          // Create FormData with files AND metadata
          const formData = new FormData();

          // Append project name and description
          formData.append("folder_name", projectName.trim());
          formData.append("description", description.trim());

          // Append web links (include a trailing entry the user typed but didn't add)
          const allWebLinks = [...webLinks];
          if (linkInput.trim()) allWebLinks.push(linkInput.trim());
          allWebLinks.forEach((link) => formData.append("web_links", link));

          // Scope the new project to the selected org (backend reads ?organization_id=).
          const orgId = Cookies.get("selected_org_id");

          // Append ONLY files that are not already errors (and preferably not already success)
          // Typically we append the files we intend to upload
          files.forEach((fileObj) => {
             // Only append files that are NOT already in ERROR state
             if (fileObj.status !== STATUS.ERROR) {
                formData.append("files", fileObj.file);
             }
          });

          // Make HTTP POST request to create folder with files
          const url = orgId
            ? `${process.env.REACT_APP_API_URL}api/v1/rfp/create-folder/?organization_id=${encodeURIComponent(orgId)}`
            : `${process.env.REACT_APP_API_URL}api/v1/rfp/create-folder/`;

          const resp = await api.post(url, formData, {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (ev) => {
              // Initial network upload progress (0-30%)
              const baseProgress = Math.min(
                30,
                Math.round((ev.loaded * 100) / ev.total)
              );
              setFiles((prev) =>
                prev.map((f) => {
                  if (f.status === STATUS.UPLOADING) {
                    return {
                      ...f,
                      progress: Math.max(f.progress, baseProgress),
                    };
                  }
                  return f;
                })
              );
            },
          });

          console.log("Folder creation response:", resp.data);

          projectInfoRef.current = {
            id: resp.data?.folder?.id,
            orgId: Cookies.get("selected_org_id"),
            name: projectName.trim(),
          };

          // If there are no files to upload, the websocket won't fire file events. We finalize directly.
          if (filesToUpload.length === 0) {
            if (ws.readyState === WebSocket.OPEN) {
              ws.close();
            }
            setIsUploadingFiles(false);
            finalizeProjectCreation([]);
          }

          // Get uploads response with pdf_keys
          const uploads = resp.data?.uploads || [];

          // Match pdf_keys to files by filename
          setFiles((prevFiles) =>
            prevFiles.map((f) => {
              const upload = uploads.find((u) => u.filename === f.file.name);
              return upload && upload.pdf_key
                ? { ...f, key: upload.pdf_key }
                : f;
            })
          );
        } catch (err) {
          console.error("🚨 Folder creation failed:", err);
          setFiles((prev) =>
            prev.map((f) =>
              f.status === STATUS.UPLOADING
                ? {
                    ...f,
                    status: STATUS.ERROR,
                    errorReason: "upload_failed",
                  }
                : f
            )
          );

          if (ws.readyState === WebSocket.OPEN) {
            ws.close();
          }
          setIsUploadingFiles(false);
          setLoading(false);
          setButtonText("Create Project");

          const backendMsg =
            err?.response?.data?.msg ||
            err?.response?.data?.error ||
            "Failed to create folder. Please try again.";

          // Handle specific errors
          if (
            /org_id/i.test(backendMsg) ||
            /not an active member/i.test(backendMsg)
          ) {
            hotToast.error(backendMsg);
          } else if (
            backendMsg.toLowerCase().includes("folder name already exists") ||
            backendMsg.toLowerCase().includes("name already exists")
          ) {
            toast.error(backendMsg);
          } else if (
            backendMsg === "Only 5 files allowed" ||
            backendMsg.includes("Trial users can upload only 5 documents")
          ) {
            toast.error(backendMsg);
          } else {
            toast.error(backendMsg);
          }
        }
      };
    } catch (error) {
      console.error("Error setting up folder creation:", error);
      setFiles((prev) =>
        prev.map((f) => ({
          ...f,
          status: STATUS.ERROR,
          errorReason: "setup_error",
        }))
      );
      setIsUploadingFiles(false);
      setLoading(false);
      setButtonText("Create Project");
      toast.error("Failed to initiate folder creation.");
    }
  };

  const finalizeProjectCreation = async (uploadedFiles) => {
    setButtonText("Finalizing...");

    try {
      // Get successfully uploaded file IDs
      // This automatically ignores failed files
      const uploadedFileIds = uploadedFiles
        .filter((file) => file.status === STATUS.SUCCESS && file.file_id)
        .map((file) => file.file_id);

      // Call parent component callback with project data
      if (onCreateProject) {
        await onCreateProject({
          projectName: projectName.trim(),
          description: description.trim(),
          fileIds: uploadedFileIds,
        });
      }

      // Show success state in button
      setButtonText("Create Project");
      setIsSuccess(true);
      setLoading(false);
      markOnboarding("project", { name: projectName.trim() });

      // Wait before closing the modal and navigating
      successTimeoutRef.current = setTimeout(() => {
        // Capture project data BEFORE handleClose, since closing the modal
        // flips `isOpen` to false and the cleanup useEffect resets projectInfoRef.
        const pInfo = projectInfoRef.current;
        handleClose();

        navigate(`/rfp-projects/project/${pInfo.id}/org/${pInfo.orgId}/project-overview`, {
          state: {
            folderId: pInfo.id,
            folderName: pInfo.name,
            orgId: pInfo.orgId,
          }
        });

      }, 500);
    } catch (error) {
      console.error("Error finalizing project:", error);
      setButtonText("Create Project");
      setIsSuccess(false);
      setLoading(false);

      const errorMessage =
        error?.response?.data?.error ||
        error.message ||
        "Failed to finalize project. Please try again.";
      toast.error(errorMessage);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleFileChange(e);
  };

  const removeFile = (indexToRemove) => {
    setFiles((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  const addWebLink = () => {
    const trimmed = linkInput.trim();
    if (!trimmed) return;
    setWebLinks((prev) => [...prev, trimmed]);
    setLinkInput("");
  };

  const removeWebLink = (indexToRemove) => {
    setWebLinks((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!projectName.trim()) {
      toast.error("Please enter a project name.");
      return;
    }

    // Check if files are still uploading
    if (isUploadingFiles) {
      toast.error("Please wait for file uploads to complete.");
      return;
    }

    // At the plan limit: show the upgrade popup now, before anything is uploaded. The form
    // stays open underneath, so "Not now" returns to it unchanged.
    const blocked = await (quotaCheckRef.current || quotaBlockedMessage("projects"));
    if (blocked) {
      emitPlanLimit(blocked, "projects");
      return;
    }

    // REMOVED: The check for failedUploads.length > 0 has been removed.
    // We now proceed to createFolderWithFiles even if there are errors.
    
    // Start folder creation with files
    await createFolderWithFiles();
  };

  const handleClose = () => {
    // Clear any pending timeout
    if (successTimeoutRef.current) {
      clearTimeout(successTimeoutRef.current);
      successTimeoutRef.current = null;
    }

    // Close WebSocket connection
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.close();
    }

    // Reset all states
    setProjectName("");
    setDescription("");
    setWebLinks([]);
    setLinkInput("");
    setFiles([]);
    setLoading(false);
    setButtonText("Create Project");
    setIsSuccess(false);
    setIsUploadingFiles(false);

    // Close modal
    onClose();
  };

  // Helper function to get file extension
  const getFileExtension = (filename) => {
    return filename.split(".").pop().toLowerCase();
  };

  // Helper function to format file size
  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + " B";
    else if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + " KB";
    else return (bytes / (1024 * 1024)).toFixed(2) + " MB";
  };

  const getFileIcon = (filename) => {
    const ext = getFileExtension(filename);

    if (ext === "pdf") {
      return <img src={pdfImg} alt="PDF" className="w-8 h-10 flex-shrink-0" />;
    } else if (ext === "xls" || ext === "xlsx" || ext === "csv") {
      return (
        <img src={xlsImg} alt="Excel" className="w-8 h-10 flex-shrink-0" />
      );
    } else if (ext === "doc" || ext === "docx") {
      return <img src={docImg} alt="Word" className="w-8 h-10 flex-shrink-0" />;
    } else {
      return (
        <img src={docImg} alt="Document" className="w-8 h-10 flex-shrink-0" />
      );
    }
  };

  // Check if we can create project
  const canCreateProject =
    projectName.trim().length > 0 && 
    !loading &&
    !isUploadingFiles;

  const canAddMoreFiles = true;

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[10050] flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm"
      onClick={handleClose}
    >
      <div
        className="bg-white rounded-xl shadow-2xl px-6 py-4 w-[90%] max-w-lg relative"
        onClick={(e) => e.stopPropagation()}
        aria-modal="true"
        role="dialog"
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-xl font-semibold text-gray-800 font-[Outfit]">
            Create New Project
          </h2>
          <button
            onClick={handleClose}
            className="text-[#52525BE3] hover:text-gray-600 transition"
            aria-label="Close"
            disabled={loading || isUploadingFiles}
          >
            <CloseIcon className="w-6 h-6" />
          </button>
        </div>

        <p className="text-sm text-gray-500 mb-4 font-[Outfit]">
          Set up a new project, add files and share with your team easily.
        </p>

        <form onSubmit={handleSubmit}>

          <div className="mb-4">
            <label
              htmlFor="projectName"
              className="block text-[14px] font-medium !text-[#3F3F46] font-[Outfit] mb-1"
            >
              Project Name <span className="text-red-500">*</span>
            </label>
            <input
              id="projectName"
              data-tour="project-name"
              type="text"
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
              placeholder="Enter Project Name"
              className="w-full px-2 py-2 h-10 border border-gray-300 rounded-lg !font-normal placeholder-[#52525BE3] font-[Outfit] transition"
              required
              disabled={loading || isSuccess}
            />
          </div>

       
          <div className="mb-4">
            <label
              htmlFor="description"
              className="block text-[14px] font-medium !text-[#3F3F46] font-[Outfit] mb-1"
            >
              Description (Optional)
            </label>
            <textarea
              id="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Add Project Description..."
              rows="2"
              className="w-full px-2 py-2 border border-gray-300 rounded-lg placeholder-[#52525BE3] font-[Outfit] resize-none transition focus:outline-none focus:ring-0 focus:border-gray-300"
              disabled={loading || isSuccess}
            />
          </div>

          <div className="mb-4">
            <label className="block text-[14px] font-medium !text-[#3F3F46] font-[Outfit] mb-1">
              Web Links (Optional)
            </label>

            {/* Already-added links */}
            {webLinks.length > 0 && (
              <div
                className={
                  webLinks.length > 4 ? "max-h-[192px] overflow-y-auto pr-1" : ""
                }
              >
                {webLinks.map((link, index) => (
                  <div key={index} className="flex items-center gap-2 mb-2">
                    <div className="flex-1 px-2 py-2 h-10 flex items-center border border-gray-300 rounded-lg font-[Outfit] text-[#3F3F46] truncate">
                      {link}
                    </div>
                    <button
                      type="button"
                      onClick={() => removeWebLink(index)}
                      className="flex-shrink-0 text-gray-400 hover:text-red-500 transition disabled:opacity-50"
                      aria-label="Remove link"
                      disabled={loading || isSuccess}
                    >
                      <RemoveIcon className="w-5 h-5" />
                    </button>
                  </div>
                ))}
              </div>
            )}

            {/* Active link input + add button */}
            <div className="flex items-center gap-2">
              <input
                type="url"
                value={linkInput}
                onChange={(e) => setLinkInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    addWebLink();
                  }
                }}
                placeholder="Add websites, reference URLs, or portal links related to this project."
                className="flex-1 px-2 py-2 h-10 border border-gray-300 rounded-lg !font-normal placeholder-[#52525BE3] font-[Outfit] transition focus:outline-none focus:ring-0 focus:border-[#C95EBE]"
                disabled={loading || isSuccess}
              />
              {linkInput.trim() && (
                <button
                  type="button"
                  onClick={addWebLink}
                  className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-[#9A6295] text-white text-xl leading-none hover:bg-[#b54eb0] transition disabled:opacity-50"
                  aria-label="Add link"
                  disabled={loading || isSuccess}
                >
                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="13" viewBox="0 0 20 13" fill="none">
  <path d="M15 10H12.975C12.6917 10 12.4583 9.90417 12.275 9.7125C12.0917 9.52083 12 9.28333 12 9C12 8.71667 12.0958 8.47917 12.2875 8.2875C12.4792 8.09583 12.7167 8 13 8H15V6C15 5.71667 15.0958 5.47917 15.2875 5.2875C15.4792 5.09583 15.7167 5 16 5C16.2833 5 16.5208 5.09583 16.7125 5.2875C16.9042 5.47917 17 5.71667 17 6V8H19C19.2833 8 19.5208 8.09583 19.7125 8.2875C19.9042 8.47917 20 8.71667 20 9C20 9.28333 19.9042 9.52083 19.7125 9.7125C19.5208 9.90417 19.2833 10 19 10H17V12C17 12.2833 16.9042 12.5208 16.7125 12.7125C16.5208 12.9042 16.2833 13 16 13C15.7167 13 15.4792 12.9042 15.2875 12.7125C15.0958 12.5208 15 12.2833 15 12V10ZM8 10H5C3.61667 10 2.4375 9.5125 1.4625 8.5375C0.4875 7.5625 0 6.38333 0 5C0 3.61667 0.4875 2.4375 1.4625 1.4625C2.4375 0.4875 3.61667 0 5 0H8C8.28333 0 8.52083 0.0958333 8.7125 0.2875C8.90417 0.479167 9 0.716667 9 1C9 1.28333 8.90417 1.52083 8.7125 1.7125C8.52083 1.90417 8.28333 2 8 2H5C4.16667 2 3.45833 2.29167 2.875 2.875C2.29167 3.45833 2 4.16667 2 5C2 5.83333 2.29167 6.54167 2.875 7.125C3.45833 7.70833 4.16667 8 5 8H8C8.28333 8 8.52083 8.09583 8.7125 8.2875C8.90417 8.47917 9 8.71667 9 9C9 9.28333 8.90417 9.52083 8.7125 9.7125C8.52083 9.90417 8.28333 10 8 10ZM7 6C6.71667 6 6.47917 5.90417 6.2875 5.7125C6.09583 5.52083 6 5.28333 6 5C6 4.71667 6.09583 4.47917 6.2875 4.2875C6.47917 4.09583 6.71667 4 7 4H13C13.2833 4 13.5208 4.09583 13.7125 4.2875C13.9042 4.47917 14 4.71667 14 5C14 5.28333 13.9042 5.52083 13.7125 5.7125C13.5208 5.90417 13.2833 6 13 6H7ZM20 5H18C18 4.16667 17.7083 3.45833 17.125 2.875C16.5417 2.29167 15.8333 2 15 2H11.975C11.6917 2 11.4583 1.90417 11.275 1.7125C11.0917 1.52083 11 1.28333 11 1C11 0.716667 11.0958 0.479167 11.2875 0.2875C11.4792 0.0958333 11.7167 0 12 0H15C16.3833 0 17.5625 0.4875 18.5375 1.4625C19.5125 2.4375 20 3.61667 20 5Z" fill="white"/>
</svg>
                </button>
              )}
            </div>
          </div>

      
          {/* <div className="mb-6">
            <div className="flex items-center justify-between mb-2">
              <label className="block text-[14px] font-medium !text-[#3F3F46] font-[Outfit]">
                Selected Files ({files.length})
              </label>
              {canAddMoreFiles && !isSuccess && (
                <button
                  type="button"
                  onClick={() =>
                    !loading &&
                    !isUploadingFiles &&
                    !isSuccess &&
                    document.getElementById("file-upload-input").click()
                  }
                  className="text-[#C95EBE] text-sm font-medium font-[Outfit] hover:underline"
                  disabled={loading || isUploadingFiles || isSuccess}
                >
                  Add Files
                </button>
              )}
            </div>

            <input
              id="file-upload-input"
              ref={fileInputRef}
              type="file"
              className="hidden"
              onChange={handleFileChange}
              accept=".pdf,.docx,.doc,.txt,.csv,.xls,.xlsx,.jpg,.jpeg,.png"
              multiple
              disabled={
                loading || isUploadingFiles || isSuccess
              }
            />

            {files.length > 0 ? (
              <div className="space-y-3 max-h-[250px] overflow-y-auto pr-2 custom-scrollbar">
                {files.map((fileObj, index) => (
                  <div
                    key={`${fileObj.file.name}-${index}`}
                    className="border border-gray-200 rounded-lg p-2"
                  >
                    <div className="flex items-center gap-3">
                 
                      {getFileIcon(fileObj.file.name)}

                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-[#171717] truncate font-[Outfit]">
                          {fileObj.file.name}
                        </p>
                        <p className="text-xs text-gray-500 font-[Outfit]">
                          {formatFileSize(fileObj.file.size)}
                        </p>
                      </div>

                      <div className="flex-shrink-0">
                        {fileObj.status === STATUS.SUCCESS ? (
                          <CheckIcon />
                        ) : fileObj.status === STATUS.ERROR ? (
                          <ErrorIcon />
                        ) : fileObj.status === STATUS.UPLOADING ? (
                          <span className="text-sm font-semibold text-gray-800">
                            {Math.round(fileObj.progress)}%
                          </span>
                        ) : !isSuccess ? (
                          <button
                            type="button"
                            onClick={() => removeFile(index)}
                            className="text-gray-400 hover:text-gray-600 transition"
                            disabled={loading || isSuccess}
                          >
                            <RemoveIcon />
                          </button>
                        ) : null}
                      </div>
                    </div>

                    {(fileObj.status === STATUS.UPLOADING ||
                      fileObj.status === STATUS.SUCCESS ||
                      fileObj.status === STATUS.ERROR) && (
                      <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-gray-200">
                        <div
                          className={`h-2 rounded-full transition-all duration-300 ease-linear ${
                            fileObj.status === STATUS.ERROR
                              ? "bg-red-500"
                              : fileObj.status === STATUS.SUCCESS
                              ? "bg-green-500"
                              : "bg-purple-600"
                          }`}
                          style={{
                            width: `${fileObj.progress}%`,
                            background:
                              fileObj.status === STATUS.UPLOADING
                                ? "linear-gradient(180deg, #C95EBE 0%, #8B55DD 100%)"
                                : undefined,
                          }}
                        ></div>
                      </div>
                    )}

                    {fileObj.status === STATUS.ERROR && (
                      <p className="mt-1 text-xs text-red-600">
                        {fileObj.errorReason === "unsupported"
                          ? "Unsupported file type"
                          : fileObj.errorReason === "duplicate"
                          ? "Duplicate file"
                          : fileObj.errorReason === "size_limit"
                          ? "File size exceeds limit"
                          : "Upload failed"}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div
                className={`border-1 border-[#E5E9FF] bg-[#FAF7FF] rounded-lg p-8 text-center cursor-pointer transition ${
                  loading || isUploadingFiles || isSuccess
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:bg-purple-50"
                }`}
                onDragOver={handleDragOver}
                onDrop={!isSuccess ? handleDrop : undefined}
                onClick={() =>
                  !loading &&
                  !isUploadingFiles &&
                  !isSuccess &&
                  document.getElementById("file-upload-input").click()
                }
              >
                <div className="text-[#BB42AE] mb-2">
                  <UploadIcon className="mx-auto" />
                </div>
                <p className="text-gray-600 font-medium font-[Outfit]">
                  Drag & drop files here or click to upload.
                </p>
                <p className="text-xs text-[#52525BE3] mt-1 font-[Outfit]">
                  Max 25 MB each, supported formats: PDF, DOCX, XLS
                </p>
              </div>
            )}
          </div> */}

        
          <div className="flex justify-center gap-3">
            <button
              type="button"
              onClick={handleClose}
              className="w-[20%] py-2 rounded-[8px] text-[#C95EBE] bg-white border border-[#C95EBE] font-medium font-[Outfit] transition disabled:opacity-50"
              disabled={loading || isUploadingFiles}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`w-[38%] py-2 rounded-[8px] text-white font-medium font-[Outfit] transition flex items-center justify-center min-w-[150px] ${
                isSuccess
                  ? "bg-[#C95EBE]"
                  : !projectName.trim() 
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#C95EBE] hover:bg-[#b54eb0]"
              }`}
              disabled={!canCreateProject || !projectName.trim()} 
            >
              {buttonText}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateProjectModal;